/**
 * Optional Zitadel OIDC. When `VITE_ZITADEL_CLIENT_ID` is set at build
 * time, the app gates behind an auth.petitgen.com sign-in. When unset
 * (e.g. the Tauri desktop build), auth is a no-op and the user goes
 * straight to Workbench — which is correct because desktop is sovereign.
 *
 * Variables (all read via Vite at build time):
 *   VITE_ZITADEL_ISSUER     default "https://auth.petitgen.com"
 *   VITE_ZITADEL_CLIENT_ID  the OIDC client id (no secret — PKCE)
 *   VITE_ZITADEL_SCOPE      default "openid profile email offline_access"
 */
export interface OidcConfig {
  enabled: boolean;
  issuer: string;
  clientId: string;
  scope: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
}

export function loadOidcConfig(): OidcConfig {
  const clientId = (import.meta.env.VITE_ZITADEL_CLIENT_ID ?? '').trim();
  const issuer = (import.meta.env.VITE_ZITADEL_ISSUER ?? 'https://auth.petitgen.com').trim();
  const scope = (import.meta.env.VITE_ZITADEL_SCOPE ?? 'openid profile email offline_access').trim();

  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  return {
    enabled: clientId.length > 0,
    issuer,
    clientId,
    scope,
    redirectUri: `${origin}/auth/callback`,
    postLogoutRedirectUri: `${origin}/`,
  };
}
